import { AxiosInstance } from 'axios'
import localStorageService from './local.storage'

export default class Interceptors {


    /**
     * Request Interceptors
     * Used to inject in the request header the access token saved in localStorage
     * @param request, Request in which it will be included in the access token
     */
    public static injectAccessToken(request: any): any {
        const { url, data } = request
        if (url?.match(/\/auth\/password$/ig) && !data.old_password) {
            return request
        }
        const token = localStorageService.getItem('access_token')
        if (token && request?.headers) {
            request.headers.Authorization = token ? `Bearer ${token}` : ''
        }
        return request
    }

    /**
     * Response Interceptor
     * Retries the request up to 2 times if the response status is 502
     * @param error The error object
     * @param instance The axios instance to use for retrying
     */
    public static async retryOn502(error: any, instance: AxiosInstance): Promise<any> {
        const { config, response } = error
        if (response && response.status === 502 && config) {
            config.retryCount = config.retryCount || 0
            if (config.retryCount < 2) {
                config.retryCount += 1
                return instance(config)
            }
        }
        return Promise.reject(error)
    }

}
